import { AxiosResponse } from 'axios';
import qs from 'qs';
import api from '~/utils/api';
import { SelectItem } from '~/types';

export async function getContractMeasurementXlsxCsv(
  tipo: 'csv' | 'xlsx',
  groups: SelectItem[],
  headOffices: SelectItem[],
  branches: SelectItem[],
  relatorio: number,
  periodo_inicial?: Date,
  periodo_final?: Date,
): Promise<AxiosResponse<any>> {
  const url = `/medicao_contratos/${tipo}`;
  const groupsIds = groups?.map(e => e.value);
  const headofficesIds = headOffices?.map(e => e.value);
  const branchesIds = branches?.map(e => e.value);
  const headers =
    tipo === 'csv'
      ? relatorio === 0
        ? { 'Content-Type': 'application/csv' }
        : { 'Content-Type': 'application/zip' }
      : { 'Content-Type': 'application/xlsx' };
  return api.get(url, {
    params: {
      relatorio,
      ...(groupsIds && { groups: groupsIds }),
      ...(headofficesIds && { headoffices: headofficesIds }),
      ...(branchesIds && { branches: branchesIds }),
      ...(periodo_inicial && { periodo_inicial }),
      ...(periodo_final && { periodo_final }),
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
    headers,
    responseType: 'blob' as 'json',
  });
}
